// Thin client for the Adroit backend API (adroit-backend). The base URL comes
// from REACT_APP_API_URL at build time; when it's unset (e.g. the API isn't
// deployed yet) every call rejects fast and callers fall back to the bundled
// content, so the site keeps working with zero backend.
const RAW_BASE = process.env.REACT_APP_API_URL || '';
const API_BASE = RAW_BASE.replace(/\/$/, '');

export const isApiConfigured = () => Boolean(API_BASE);

// Low-level request helper with an abort timeout so a slow/unreachable API
// never hangs the UI. Throws an Error (with .status/.data when available).
async function request(path, { method = 'GET', body, timeout = 8000 } = {}) {
    if (!API_BASE) {
        throw new Error('API not configured');
    }

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);

    try {
        const res = await fetch(`${API_BASE}${path}`, {
            method,
            headers: body ? { 'Content-Type': 'application/json' } : undefined,
            body: body ? JSON.stringify(body) : undefined,
            signal: controller.signal,
        });

        // 204 / empty bodies parse to {}.
        let data = {};
        try {
            data = await res.json();
        } catch (e) {
            data = {};
        }

        if (!res.ok) {
            // Backend error shape: { error, details? }.
            const err = new Error(data.error || `Request failed (${res.status})`);
            err.status = res.status;
            err.data = data;
            throw err;
        }

        return data;
    } finally {
        clearTimeout(timer);
    }
}

export const apiGet = (path) => request(path);
export const apiPost = (path, body) => request(path, { method: 'POST', body });

// Fire-and-forget page-view beacon. Never throws — analytics must not affect UX.
export function trackPageView(path) {
    if (!API_BASE) return;
    request('/analytics/collect', { method: 'POST', body: { path }, timeout: 4000 }).catch(() => {});
}
